import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <rect height="69.75" rx="10.125" stroke="white" strokeWidth="2.25" width="69.75" x="1.125" y="1.125" />
    <path
      d="M24.75 14.625C24.75 16.489 26.261 18 28.125 18H41.625C43.489 18 45 16.489 45 14.625C45 12.761 43.489 11.25 41.625 11.25H28.125C26.261 11.25 24.75 12.761 24.75 14.625Z"
      fill="white"
    />
    <path
      clipRule="evenodd"
      d="M36.0001 33.19L32.031 37.1591L35.9653 41.0934L37.4044 39.6543L36.0001 38.25V33.19ZM51.6543 25.4044L53.3571 23.7015C54.4436 22.6151 54.4436 20.8536 53.3571 19.7672C52.2707 18.6808 50.5093 18.6808 49.4228 19.7672L47.5637 21.6264C49.102 22.6964 50.4768 23.9695 51.6543 25.4044Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      d="M34.875 19.1549C36.5738 19.2412 38.559 19.514 40.497 19.9674C42.8969 20.5288 45.1216 21.3434 46.6253 22.3481C49.7704 24.4496 52.2217 27.4365 53.6692 30.9312C55.1167 34.4258 55.4955 38.2712 54.7575 41.9811C54.0849 45.3628 52.5119 48.4934 50.2131 51.0466L34.875 38.8327V19.1549Z"
      stroke="white"
      strokeWidth="2.25"
    />
    <path
      d="M56.25 38.25C56.25 42.2551 55.0624 46.1702 52.8373 49.5003C50.6122 52.8304 47.4495 55.4259 43.7493 56.9586C40.0491 58.4912 35.9775 58.8923 32.0494 58.1109C28.1213 57.3296 24.5131 55.4009 21.6811 52.5689C18.8491 49.7369 16.9204 46.1287 16.1391 42.2006C15.3577 38.2725 15.7588 34.2009 17.2914 30.5007C18.8241 26.8005 21.4196 23.6378 24.7497 21.4127C28.0798 19.1876 31.9949 18 36 18V38.25H56.25Z"
      fill="white"
    />
    <path d="M38.25 13.5L38.25 20.25L31.5 20.25L31.5 13.5L38.25 13.5Z" fill="white" />
  </>,
  'Clock',
)
